import axios from "axios";

// Base API client with Authorization
const apiClient = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  headers: {
    "Content-Type": "application/json",
  },
});
const apiUrl = process.env.REACT_APP_API_URL;


apiClient.interceptors.request.use((config) => {
  const token = localStorage.getItem("accessToken");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});
export default apiClient;

// Fetch total applications and posts
export const fetchApplicationsAndPosts = async (userId) => {
  console.log("usewris", userId)
  
  // Guard clause: Check if userId is valid before making API call
  if (!userId || userId === null || userId === undefined) {
    throw new Error("Invalid userId: cannot fetch applications and posts without valid user ID");
  }
  
  try {
    const response = await apiClient.get(`recruiters/${userId}/total_application_and_post/`);
    return response.data;
  } catch (error) {
    if (error.response && error.response.status === 401) {
      throw new Error("Unauthorized");
    }
    throw error;
  }
};

export const fetchPostsChartData = async (userId) => {
  // Guard clause: Check if userId is valid before making API call
  if (!userId || userId === null || userId === undefined) {
    throw new Error("Invalid userId: cannot fetch posts chart data without valid user ID");
  }
  
  try {
    const response = await apiClient.get(`${apiUrl}recruiters/${userId}/candidates_applied_to_RHposts/`);
    return response.data;
  } catch (error) {
    if (error.response && error.response.status === 401) {
      throw new Error("Unauthorized");
    }
    throw error;
  }
};

export const getScoresForPost = async (userId, apiUrl) => {
  // Guard clause: Check if userId is valid before making API call
  if (!userId || userId === null || userId === undefined) {
    throw new Error("Invalid userId: cannot fetch scores for post without valid user ID");
  }
  
  const response = await fetch(
    `${apiUrl}authentication/scores-for-post/${userId}/`
  );
  
  // if (!response.ok) {
  //   throw new Error("Failed to fetch score statistics");
  // }
  
  return await response.json();
};

const fetchRecruiter = async (userId) => {
  // Guard clause: Check if userId is valid before making API call
  if (!userId || userId === null || userId === undefined) {
    throw new Error("Invalid userId: cannot fetch recruiter data without valid user ID");
  }

  const response = await fetch(`${apiUrl}recruiters/${userId}/find/`, {
    headers: {
      "Content-type": "application/json",
      Authorization: "Bearer " + localStorage.getItem("accessToken"),
    },
  });

  if (response.status === 401) {
    throw new Error("Unauthorized");
  }

  return await response.json();
};

export { fetchRecruiter };

const fetchNbrPostsApplications = async (userId) => {
  // Guard clause: Check if userId is valid before making API call
  if (!userId || userId === null || userId === undefined) {
    throw new Error("Invalid userId: cannot fetch posts applications count without valid user ID");
  }
  
  const response = await fetch(
    `${apiUrl}recruiters/${userId}/total_application_and_post/`,
    {
      headers: {
        "Content-type": "application/json",
        Authorization: "Bearer " + localStorage.getItem("accessToken"),
      },
    }
  );

  if (response.status === 401) {
    throw new Error("Unauthorized");
  }
  return await response.json();
};

export { fetchNbrPostsApplications };

// Fetch hired applications count
const fetchHiredApplicationsCount = async (userId) => {
  // Guard clause: Check if userId is valid before making API call
  if (!userId || userId === null || userId === undefined) {
    throw new Error("Invalid userId: cannot fetch hired applications count without valid user ID");
  }
  
  const response = await fetch(
    `${apiUrl}authentication/hired-applications-count/${userId}/`,
    {
      headers: {
        "Content-type": "application/json",
        Authorization: "Bearer " + localStorage.getItem("accessToken"),
      },
    }
  );

  if (response.status === 401) {
    throw new Error("Unauthorized");
  }
  return await response.json();
};

export { fetchHiredApplicationsCount };


const CLOUDINARY_PRESET_KEY = "tpjsjr7k";
const CLOUDINARY_CLOUD_NAME = "dwckvxlca";

export const userProfileService = {
  async updateProfile(userId, formData) {
    // Guard clause: Check if userId is valid before making API call
    if (!userId || userId === null || userId === undefined) {
      throw new Error("Invalid userId: cannot update profile without valid user ID");
    }
    
    const updatableFields = {
      company: formData.company,
      first_name: formData.first_name,
      last_name: formData.last_name,
      address: formData.address,
      city: formData.city,
      country: formData.country,
      image: formData.image,
      postal_code: formData.postal_code,
      email: formData.email,
      comp_description: formData.comp_description,
      comp_industry: formData.comp_industry
    };

    const response = await axios.patch(
      `${apiUrl}recruiters/${userId}/update/`,
      updatableFields,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
        },
      }
    );
    return response.data;
  },

  async uploadImage(file) {
    const formData = new FormData();
    formData.append("file", file);
    formData.append("upload_preset", CLOUDINARY_PRESET_KEY);
    
    const response = await axios.post(
      `https://api.cloudinary.com/v1_1/${CLOUDINARY_CLOUD_NAME}/image/upload`,
      formData
    );
    return response.data.secure_url;
  }
};